import { EditIcon, Trash2Icon } from 'lucide-react';
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../shadcn/ui/table';
import Constants from '@/constants';
import { Product } from '@/entities/product';
import { useProduct } from '@/hook/useProduct';

// interface ProductFormData {
//   nome: string;
//   descricao: string;
//   valor: string;
//   codprod: string;
//   comissao: string; {produto.price % 1 !== 0 ? `${produto.price.toFixed(2)}`.replace('.', ',') : `${produto.price},00`}
// }

type ProductsProps = {
  data: Product[];
  onProductDelete: (index: number) => void;
  setOpen: (value: boolean) => void;
  open: boolean;
  setSelectedProduct: (data: any) => void;
  setEdit: (value: boolean) => void;
  setIdToEdit: (value: number) => void;
}

const testandoPontos = () => {
  const letra = 'teste.12';
  const testNumber = '2.000.000,20';
  const testNumber2 = 2000000;
  const paraTestar = testNumber2.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, });

};

const TableView: React.FC<ProductsProps> = ({ data, onProductDelete, setOpen, setSelectedProduct, setEdit, setIdToEdit, open }) => {
  const { productsUse, selectedProduct, deleteProduct, updateProduct } = useProduct();

  function handleProductSubmit(data: any): void {

    setOpen(false);
  }

  return (
    <div className='m-4 rounded-md sm:border'>
      <Table>
        <TableHeader>
          <TableRow className= 'mx-2 bg-indigo-50'>
            {Constants.LISTA_COLUNAS_PRODUTOS.map((coluna) => (
              <TableHead className='h-10' key={coluna}>{coluna}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((produto, index) => { // Loga apenas deploy

            return (
              <TableRow className='mx-2' key={index}>
                <TableCell>{produto.name}</TableCell>
                <TableCell>{produto.description}</TableCell>
                <TableCell>
                  R$ {produto.price.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell>
                  R$ {(produto.deploy ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell>
                  <div className="flex gap-2">
                    <button title="Apagar">
                      <Trash2Icon
                        onClick={() => {
                          onProductDelete(index);
                          deleteProduct(produto.id);
                        }}
                        size={26}
                        className="bg-red-600 hover:bg-red-800 rounded-md p-1"
                      />
                    </button>
                    <button
                      title="Editar"
                      onClick={() => {
                        setOpen(true);
                        setSelectedProduct(produto);
                        setEdit(true);
                        setIdToEdit(produto.id);
                        updateProduct(produto.id,produto);
                      }}
                    >
                      <EditIcon size={26} className="bg-lime-600 hover:bg-lime-800 rounded-md p-1" />
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}

        </TableBody>
      </Table>
    </div>
  );
};

export default TableView;
